import { CONTRACT_TERMS_TEXT } from '../../contractTerms';
import type { CreateContractPayload } from './adminContractApi';

export const CONTRACT_TYPES = [
  { id: 'web', title: '웹 플랫폼 제작' },
  { id: 'app', title: '모바일 앱 제작' },
  { id: 'maintenance', title: '유지보수 · 고도화' },
  { id: 'consulting', title: '기획 · 컨설팅' },
] as const;

export const DEFAULT_TERMS_TEXT = CONTRACT_TERMS_TEXT;

export const PROVIDER_INFO = {
  companyName: '예플랫',
  representative: '이요한',
  businessNumber: '642-37-01639',
  contact: '1551-5948',
  address: '대구광역시 달성군 다사읍 달구벌대로 174길 50, B202호',
  accountNumber: 'KB국민은행 676301-04-300117 이요한(예플랫)',
} as const;

export type StatusFilter = 'ALL' | 'pending' | 'signed';

export function createEmptyForm(): CreateContractPayload {
  return {
    customer_name: '',
    phone: '',
    contract_type: 'web',
    contract_name: '',
    product_name: '',
    company_name: '',
    representative: '',
    business_number: '',
    email: '',
    address: '',
    build_cost: '',
    build_period: '',
    maintenance_fee: '',
    maintenance_period: '',
    payment_terms: [{ category: '', amount: '', condition: '' }],
    special_notes: '',
    terms_text: DEFAULT_TERMS_TEXT,
  };
}

export function splitPhoneDigits(phone?: string | null): [string, string, string] {
  const raw = String(phone || '').trim();
  if (raw.includes('-')) {
    const [p1 = '', p2 = '', p3 = ''] = raw.split('-').map((part) => part.replace(/\D/g, ''));
    return [p1, p2, p3];
  }
  const digits = raw.replace(/\D/g, '');
  return [digits.slice(0, 3), digits.slice(3, 7), digits.slice(7, 11)];
}

export function formatAmountInput(value: string): string {
  const digits = value.replace(/[^0-9]/g, '');
  if (!digits) return '';
  return Number(digits).toLocaleString('ko-KR');
}

export function formatDateTime(value?: string | null) {
  if (!value) return '—';
  const normalized = String(value).replace(' ', 'T');
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getContractTypeTitle(type: string) {
  return CONTRACT_TYPES.find((item) => item.id === type)?.title || type || '—';
}

export function getStatusLabel(status: string) {
  return status === 'signed' ? '서명 완료' : '서명 대기';
}

export function displayValue(value?: string | null) {
  const text = String(value || '').trim();
  return text || '—';
}

export function getSignatureImageSrc(value?: string | null) {
  const text = String(value || '').trim();
  if (!text.startsWith('data:image/')) return null;
  return text;
}

export function getSignatureText(value?: string | null) {
  const text = String(value || '').trim();
  return text || null;
}

export function hasCustomerSignature(contract: {
  status?: string;
  signature_name?: string | null;
  signature_image?: string | null;
}) {
  if (getSignatureImageSrc(contract.signature_image)) return true;
  if (contract.status === 'signed' && getSignatureText(contract.signature_name)) return true;
  return false;
}
